import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv } from '../TextStyle'
import { codeItems, codeLinks } from './CodeItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

export const CodePage = () => {
  return (
    <>
      <Head
        title="行動規範"
        description="トライアルホールディングスの行動規範を掲載しています。"
        ogp={{ type: 'article', url: 'legal/code/' }}
      />
      <CodeContainer>
        <SectionTitle
          titleText="Code of Conduct"
          subTitleText="行動規範"
          color="normal"
        />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <Index columnGap={64} listType="article" links={codeLinks} />
        <Spacer h={{ pc: 70, sp: 39 }} />
        {codeItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < codeItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </CodeContainer>
    </>
  )
}
CodePage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: '行動規範', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const CodeContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }
`
